import { authToken } from '@wellesley/auth'
import {
  useLazyGetApiV1AppsUserQuery,
  useLazyGetApiV1AppsQuery,
} from '../../appsApi'
import { Application } from '@wellesley/openapi'
import { useCallback } from 'react'

export const usePersonalAppsList = () => {
  const [getAppsUser] = useLazyGetApiV1AppsUserQuery()
  const [getGuestApps] = useLazyGetApiV1AppsQuery()

  const getApps = useCallback(
    async (): Promise<Application[]> =>
      authToken.hasToken() ? getAppsUser().unwrap() : getGuestApps().unwrap(),
    [getAppsUser, getGuestApps],
  )

  return getApps
}
